<div class="rounded-2xl bg-gray-000 text-xs font-medium pb-2">
	<table class="w-full table-fixed border-separate border-spacing-x-0.5 border-spacing-y-0.5">
		<colgroup>
			<col class="w-[50%]" />
			<col class="w-[50%]" />
		</colgroup>
		<thead>
			<tr>
				<th class="py-2 pl-1.5 pr-3 text-gray-600">
					<div class="flex items-center justify-between gap-2">
						<span>حجم</span>
						<span>قیمت</span>
					</div>
				</th>
				<th class="py-2 pl-3 pr-1.5 text-gray-600">
					<div class="flex items-center justify-between gap-2">
						<span>قیمت</span>
						<span>حجم</span>
					</div>
				</th>
			</tr>
		</thead>
		<tbody>
			@for (depth of rows(); track i; let i = $index) {
				@let buyProgressBarWidth =
					maxQuantity() ? (depth.bestBuyLimitQuantity * 100) / maxQuantity() + '%' : '0%';
				@let sellProgressBarWidth =
					maxQuantity() ? (depth.bestSellLimitQuantity * 100) / maxQuantity() + '%' : '0%';
				@let isBuyEmpty = depth.bestBuyLimitPrice === 0 && depth.bestBuyLimitQuantity === 0;
				@let isSellEmpty = depth.bestSellLimitPrice === 0 && depth.bestSellLimitQuantity === 0;
				<tr class="not-first:border-t-4 not-first:border-transparent">
					<td>
						<div class="relative h-6">
							<div class="pointer-events-none absolute inset-0 overflow-hidden">
								<div
									class="absolute inset-y-0 left-0 max-w-[calc(100%-0.55rem)] rounded-sm bg-green-200 transition-[width] duration-500 ease-out"
									data-testid="market-depth-buy-progress"
									[style.width]="buyProgressBarWidth"></div>
							</div>
							<div
								class="relative flex h-full items-center justify-between gap-2 pt-2 pr-3 pb-2 pl-1.5 tabular-nums"
								[class.text-gray-400]="isBuyEmpty"
								[class.pointer-events-none]="isBuyEmpty"
								[class.text-gray-900]="!isBuyEmpty">
								<span
									class="cursor-pointer"
									data-testid="market-depth-buy-quantity"
									(click)="onBuyQuantityClick(i, depth.bestBuyLimitPrice)">
									<ui-number format="1.0-0" [value]="depth.bestBuyLimitQuantity" />
								</span>
								<ui-popover position="right" trigger="hover">
									<span
										trigger
										class="cursor-pointer"
										data-testid="market-depth-buy-price"
										(click)="onPriceClick(depth.bestBuyLimitPrice)">
										<ui-number format="1.0-0" [value]="depth.bestBuyLimitPrice" />
									</span>
									<div
										content
										dir="ltr"
										class="flex min-w-4 flex-col gap-2 rounded-lg text-gray-900"
										[class.text-green-500]="depth.bestBuyLimitPrice > previousClosePrice()"
										[class.text-red-500]="depth.bestBuyLimitPrice < previousClosePrice()">
										{{
											(depth.bestBuyLimitPrice - previousClosePrice()) /
												(previousClosePrice() || 1) | percent: '1.1-2'
										}}
									</div>
								</ui-popover>
							</div>
						</div>
					</td>
					<td>
						<div class="relative h-6">
							<div class="pointer-events-none absolute inset-0 overflow-hidden rounded">
								<div
									class="absolute inset-y-0 right-0 max-w-[calc(100%-0.55rem)] rounded-sm bg-red-200 transition-[width] duration-500 ease-out"
									data-testid="market-depth-sell-progress"
									[style.width]="sellProgressBarWidth"></div>
							</div>
							<div
								class="relative flex h-full items-center justify-between gap-2 pt-2 pr-1.5 pb-2 pl-3 tabular-nums"
								[class.text-gray-400]="isSellEmpty"
								[class.pointer-events-none]="isSellEmpty"
								[class.text-gray-900]="!isSellEmpty">
								<ui-popover position="left" trigger="hover">
									<span
										trigger
										class="cursor-pointer"
										data-testid="market-depth-sell-price"
										(click)="onPriceClick(depth.bestSellLimitPrice)">
										<ui-number format="1.0-0" [value]="depth.bestSellLimitPrice" />
									</span>
									<div
										content
										dir="ltr"
										class="flex min-w-4 flex-col gap-2 rounded-lg text-gray-900"
										[class.text-green-500]="depth.bestSellLimitPrice > previousClosePrice()"
										[class.text-red-500]="depth.bestSellLimitPrice < previousClosePrice()">
										{{
											(depth.bestSellLimitPrice - previousClosePrice()) /
												(previousClosePrice() || 1) | percent: '1.1-2'
										}}
									</div>
								</ui-popover>
								<span
									class="cursor-pointer"
									data-testid="market-depth-sell-quantity"
									(click)="onSellQuantityClick(i, depth.bestSellLimitPrice)">
									<ui-number format="1.0-0" [value]="depth.bestSellLimitQuantity" />
								</span>
							</div>
						</div>
					</td>
				</tr>
			}
		</tbody>
	</table>
</div>
